import { $, $$, getNextSibling } from '../../../shared/js/utils/dom';
import { Accordion } from '@3pc/accordion';
import {
  getHeaderHeight,
  getHeaderHeightPaddingBottom,
  getHeaderIsSticky,
} from '../../organisms/header/header';
import Bus from '../../../shared/js/modules/event-bus';
import { isMobile } from '../../../shared/js/globals/breakpoints';
import { initRedirects } from '../../_accessibility/focus-redirect';

const navMain = $('.nav-main');
let navMainIsOpen = false;
const toggles = navMain ? $$('.nav-main__expand-toggle', navMain) : [];
const accordionInstancesPerNavLevel = {};
const NavMainAccordionInstances = [];

class NavMainAccordion {
  constructor(params) {
    this.toggle = params.toggle;
    this.content = params.content;
    this.contentInner = params.contentInner;
    this.closeBtn = $('.nav-main__expand-close', this.contentInner);
    this.navLevel = parseInt(this.toggle.closest('[data-level]').dataset.level);
    this.accordionInstance = undefined;
    this.uniqueStr = `${Math.floor(
      Math.random() * Math.floor(Math.random() * Date.now())
    )}`;
  }

  init() {
    if (!this.toggle || !this.content || !this.contentInner) return;

    this.setupaccordion();
    Bus.subscribe(
      'navmain_close-below-level',
      'NavMainCloseBelowLevel',
      this.closeBelowNavLevel
    );
    Bus.subscribe(
      'overlay_hide',
      `NavMainOverlayClose-${this.uniqueStr}`,
      this.close.bind(this)
    );
    Bus.subscribe(
      'header-quicklinks_open',
      `NavMainQuicklinksClose-${this.uniqueStr}`,
      this.close.bind(this)
    );
    Bus.subscribe('resize', 'NavMainResize', this.onResize.bind(this));
    this.toggle.addEventListener('keydown', this.onKeydown.bind(this));
    this.content.addEventListener('keydown', this.onKeydown.bind(this));
  }

  setupaccordion() {
    const handler = this.toggle;
    const target = this.content;
    const targetInner = this.contentInner;

    this.accordionInstance = new Accordion({
      target,
      targetInner,
      handler,
      duration: 300,
      noInlineStyles: true,
      initOpened: false,
      openClassName: 'is-open',
      toggleStart: (_, state) => {
        // IF 1st navLevel emit event 'navmain_open'
        if (state === 'show' && this.navLevel === 1 && !isMobile) {
          navMainIsOpen = true;
        }

        if (state !== 'show' && this.navLevel === 1 && !isMobile)
          navMainIsOpen = false;

        if (navMainIsOpen) {
          navMain.classList.add('nav-main--is-open');
          Bus.broadcast('navmain_open', null);
        }

        if (this.closeBtn) {
          this.closeBtn.style.transform = '';
          this.closeBtn.style.transition = '';
        }
        this.contentInner.style.width = '';
        this.contentInner.style.paddingRight = '';
        this.contentInner.style.maxHeight = '';
        this.contentInner.style.overflow = 'hidden';

        if (
          getHeaderIsSticky() &&
          state === 'show' &&
          this.navLevel === 1 &&
          !isMobile
        ) {
          const availableHeight =
            window.innerHeight -
            getHeaderHeight() +
            getHeaderHeightPaddingBottom();

          this.contentInner.style.maxHeight = `${availableHeight}px`;
          this.closeBtn.style.transition = 'transform 50ms';
        }
      },
      toggleEnd: (_, state) => {
        // IF 1st navLevel emit event 'navmain_close'
        if (state !== 'show' && this.navLevel === 1 && !isMobile) {
          if (!navMainIsOpen) {
            navMain.classList.remove('nav-main--is-open');
            Bus.broadcast('navmain_close', null);
          }
        }

        if (
          getHeaderIsSticky() &&
          state === 'show' &&
          this.navLevel === 1 &&
          !isMobile
        ) {
          const availableHeight =
            window.innerHeight -
            getHeaderHeight() +
            getHeaderHeightPaddingBottom();

          if (this.contentInner.clientHeight < availableHeight) return;

          const paddingRight = window
            .getComputedStyle(this.content)
            .getPropertyValue('padding-right');

          this.contentInner.style.overflowY = 'auto';
          this.contentInner.style.width = `calc(100% + ${paddingRight}`;
          this.contentInner.style.paddingRight = paddingRight;
          this.closeBtn.style.transform = 'translateX(20px)'; // 20px scrollbar width
        }

        // Close below navLevel on close of above level
        if (state !== 'show')
          Bus.broadcast('navmain_close-below-level', {
            belowLevel: this.navLevel + 1,
          });
      },
    });

    this.accordionInstance.init();

    // Store accordion according to its nav level
    accordionInstancesPerNavLevel[`nav-level-${this.navLevel}`] =
      accordionInstancesPerNavLevel[`nav-level-${this.navLevel}`] || [];
    accordionInstancesPerNavLevel[`nav-level-${this.navLevel}`].push(
      this.accordionInstance
    );
  }

  closeBelowNavLevel(e) {
    const closeLevel = e.belowLevel;
    const levelInstances =
      accordionInstancesPerNavLevel[`nav-level-${closeLevel}`];
    if (levelInstances)
      levelInstances.forEach(instance => {
        if (instance.show) {
          instance.close();
          instance.isAnimating = false;
        }
      });
  }

  close() {
    if (this.accordionInstance.show) {
      this.accordionInstance.close();
      this.accordionInstance.isAnimating = false;
      this.toggle.focus();
    }
  }

  emitNavMainStateEvent() {
    if (this.accordionInstance.show) {
      Bus.broadcast('navmain_open', null);
      return;
    }
    Bus.broadcast('navmain_close', null);
  }

  // First nav level

  setupFirstNavLevelaccordion() {
    this.accordionInstance.closeInstances = [];

    if (this.navLevel !== 1) return;

    // Unbind previous eventListener
    if (this.closeBtn)
      this.closeBtn.removeEventListener('click', this.close.bind(this));

    if (this.accordionInstance?.el) {
      this.accordionInstance.el.removeEventListener(
        'focusout',
        this.closeFirstNavLevelaccordionOnFocusout
      );
      this.accordionInstance.handler.removeEventListener(
        'focusout',
        this.closeFirstNavLevelaccordionOnFocusout
      );
    }

    // IF desktop
    if (!isMobile) {
      // Bind close button
      if (this.closeBtn)
        this.closeBtn.addEventListener('click', this.close.bind(this));
      // Only allow one first level nav accordion to be open at a time,
      this.accordionInstance.closeInstances = accordionInstancesPerNavLevel[
        'nav-level-1'
      ].filter(accordion => accordion !== this.accordionInstance);

      // Close first level nav accordion if focus leaves.
      if (this.accordionInstance?.el) {
        this.accordionInstance.el.addEventListener(
          'focusout',
          this.closeFirstNavLevelaccordionOnFocusout.bind(this)
        );
        this.accordionInstance.handler.addEventListener(
          'focusout',
          this.closeFirstNavLevelaccordionOnFocusout.bind(this)
        );
      }
    }
  }

  closeFirstNavLevelaccordionOnFocusout(e) {
    if (
      this.accordionInstance.show &&
      !this.accordionInstance.el.contains(e.relatedTarget) &&
      !e.relatedTarget !== this.accordionInstance.handler
    )
      this.accordionInstance.close();
    this.accordionInstance.isAnimating = false;
  }

  // Event handler

  onAllaccordionReady() {
    this.setupFirstNavLevelaccordion();
  }

  onResize() {
    this.setupFirstNavLevelaccordion();
  }

  onKeydown(e) {
    if (e.key === 'Escape' && navMainIsOpen) this.close();
  }
}

// General accordion setup
toggles.forEach(toggle => {
  const content = getNextSibling(toggle, '.nav-main__expand-content');
  const contentInner = $('.nav-main__expand-content-inner', content);

  const navItemaccordion = new NavMainAccordion({
    toggle,
    content,
    contentInner,
  });

  navItemaccordion.init();
  NavMainAccordionInstances.push(navItemaccordion);
});

// Things to be done when all accordion are initialized.
NavMainAccordionInstances.forEach(instance => {
  instance.onAllaccordionReady();
});

// Focus Handling

const navMainFocusHandler = () => {
  // Collect elements
  const firstLinkFirstLevel = $('[data-level="1"] > .nav-main__link');
  const closeButtons = $$('.nav-main__expand-close');
  const toggleButtons = $$('.nav-main__expand-toggle');

  // Element configs
  const firstLinkFirstLevelConfig =
    "{ 'smartphone': { 'previous': { 'selector': '.header__nav-main-burger' } }, 'desktop': {} }";
  const closeButtonsConfig =
    "{ 'desktop': {'next': {'selectClosestElement': true, 'selector': '.nav-main__item .nav-main__expand-toggle'} } }";
  const toggleButtonsConfig =
    "{ 'desktop' : {'previous': {'selectClosestElement': true, 'selector': '.nav-main__item .nav-main__expand-close'} } }";

  // Write config on element
  firstLinkFirstLevel?.setAttribute(
    'data-focus-redirect',
    firstLinkFirstLevelConfig
  );
  closeButtons?.map(closeButton =>
    closeButton.setAttribute('data-focus-redirect', closeButtonsConfig)
  );
  toggleButtons?.map(toggleButton =>
    toggleButton.setAttribute('data-focus-redirect', toggleButtonsConfig)
  );

  // Init redirect on elements in accordance with their config
  initRedirects([firstLinkFirstLevel, ...toggleButtons, ...closeButtons]);
};

navMainFocusHandler();
